import { render, staticRenderFns } from "./ChartFooter.vue?vue&type=template&id=632f7861&scoped=true&"
var script = {}
import style0 from "./ChartFooter.vue?vue&type=style&index=0&id=632f7861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f7861",
  null
  
)

export default component.exports